export const invitesKeys = {
  all: () => ["invites"],
  list: (targetType: string, targetId: number | null) => [
    ...invitesKeys.all(),
    "list",
    targetType,
    String(targetId)
  ],
  single: (targetId: number, profileId: number) => ["invite", targetId.toString(), profileId.toString()]
};
